module.exports = __webpack_public_path__ + "static/media/ic_medal_bronze.467491c7.png";